import { createContext, useContext, useState, ReactNode } from 'react';
import AgendarConsultaModal from '@/components/booking/AgendarConsultaModal';

interface BookingContextType {
  openBooking: (serviceId?: string) => void;
  closeBooking: () => void;
  isOpen: boolean;
}

const BookingContext = createContext<BookingContextType | undefined>(undefined);

export const useBooking = () => {
  const context = useContext(BookingContext);
  if (!context) {
    throw new Error('useBooking must be used within a BookingProvider');
  }
  return context;
};

interface BookingProviderProps {
  children: ReactNode;
}

export const BookingProvider = ({ children }: BookingProviderProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [preselectedService, setPreselectedService] = useState<string | undefined>(undefined);

  const openBooking = (serviceId?: string) => {
    setPreselectedService(serviceId);
    setIsOpen(true);
  };

  const closeBooking = () => {
    setIsOpen(false);
    // Clear preselected service after modal closes
    setTimeout(() => setPreselectedService(undefined), 300);
  };

  return (
    <BookingContext.Provider value={{ openBooking, closeBooking, isOpen }}>
      {children}
      <AgendarConsultaModal
        isOpen={isOpen}
        onClose={closeBooking}
        preselectedService={preselectedService}
      />
    </BookingContext.Provider>
  );
};
